import * as actionTypes from './action-types'

export const fetchHome = () => ({
  type: actionTypes.HOME,
  payload: null,
})
